(function () {
	// Back To School 2022 -- Datalayer push
	var btsMessageBarCta = document.querySelector('.message-bar.bts .button');

	btsMessageBarCta.addEventListener('click', function () {
		if (typeof window.dataLayer !== 'undefined') {
			dataLayer.push({
				"event": "av.genericEvent",
				"eventCategory": "CTA > Other",
				"eventAction": "BTS Discount",
				"eventLabel": window.location.href
			});
		}
	}, {
		once: true
	});
})();
